import React, { useCallback } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { Translation as T } from "@awe-web/shared/lib";
import { useToggleVisibility } from "@awe-web/shared/lib";
import SelectStationAndTime from "./select_station_and_time.jsx";

const CHANGE_STATION_AND_TIME = "FSD0000261";

export default function MinimalSelectedStationAndTime({
  reservationPath,
  coStationShortDescr,
  formattedCoDateTime,
  formattedCiDateTime,
  withEditButton
}) {
  const {isComponentVisible, toggleComponentVisible} = useToggleVisibility();

  const renderSummary = useCallback(() => {

    if (isComponentVisible) {
      return (
        <T className="minimal-selected-station-and-time__heading" code={CHANGE_STATION_AND_TIME} />
      );
    } else {
      return (
        <div>
          <div className="minimal-selected-station-and-time__station">{coStationShortDescr}</div>
          <div>{formattedCoDateTime} &ndash; {formattedCiDateTime}</div>
        </div>
      );
    }
  }, [coStationShortDescr, formattedCiDateTime, formattedCoDateTime, isComponentVisible]);

  const renderBody = useCallback(() => {
    return isComponentVisible
      ? <SelectStationAndTime reservationPath={reservationPath} className="minimal-selected-station-and-time__form" />
      : null;
  }, [isComponentVisible, reservationPath]);
  
  const toggleButtonClassNames = classnames("minimal-selected-station-and-time__toggle-button", {
    "minimal-selected-station-and-time__toggle-button--expanded": isComponentVisible
  });
  
  const renderToggleButton = useCallback(() => {
    return withEditButton
      ? <button className={toggleButtonClassNames} onClick={toggleComponentVisible}></button>
      : null;
  }, [toggleButtonClassNames, toggleComponentVisible, withEditButton]);

  return (
    <div className="minimal-selected-station-and-time">
      <div className="minimal-selected-station-and-time__summary">
        {renderSummary()}
        {renderToggleButton()}
      </div>
      {renderBody()}
    </div>
  );
}

MinimalSelectedStationAndTime.propTypes = {
  reservationPath: PropTypes.oneOf(["B2B", "B2C"]).isRequired,
  coStationShortDescr: PropTypes.string,
  formattedCoDateTime: PropTypes.string,
  formattedCiDateTime: PropTypes.string,
  withEditButton: PropTypes.bool
};
